import updateSearchFields from "@MasterBluePrint/Store/Pages/RfqMyQuotes/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@MasterBluePrint/Widgets/RfqMyQuotes/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { CustomApplicationState } from "@MasterBluePrint/Store/CustomApplicationState";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        parameter: state.rfqMyQuotes.getQuotesParameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface QuoteSearchFieldQuoteTotalOpertatorStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const orderTotalOperatorStyles: QuoteSearchFieldQuoteTotalOpertatorStyles = {};
const styles = orderTotalOperatorStyles;

class QuoteSearchFieldQuoteTotal extends React.Component<Props> {
    quoteTotalOperator = ["Greater Than", "Less Than", "Equal To"];

    handleChange = (event: React.FormEvent<HTMLSelectElement>): void => {
        this.props.updateSearchFields({ quoteTotalOperator: event.currentTarget.value });
    };

    render() {
        const value = this.props.parameter.quoteTotalOperator || "";

        return (
            <SearchFieldWrapper extendedStyles={styles.wrapper}>
                <Select
                    data-test-selector="quote_filterOrderTotalOperator"
                    label={translate("Quote Total")}
                    {...styles.select}
                    value={value}
                    onChange={this.handleChange}
                >
                    <option value="">{translate("Select quote total")}</option>
                    {this.quoteTotalOperator.map(operator => (
                        <option key={operator} value={operator}>
                            {/* this is valid, our rule isn't smart enough to handle this case */}
                            {/* eslint-disable-next-line spire/avoid-dynamic-translate */}
                            {translate(operator)}
                        </option>
                    ))}
                </Select>
            </SearchFieldWrapper>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QuoteSearchFieldQuoteTotal),
    definition: {
        group: "RFQ My Quotes",
        displayName: "Quote Total Operator",
    },
};

export default widgetModule;
